module.exports = __webpack_public_path__ + "img/btn-arrow-icon.482bd4b4.svg";